import { useDisclosure, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { SingleRowList } from "../../components/Notification/SingleRowList";
import { useNavigate } from "react-router-dom";
import NotificationService from "../../services/Notification";
export const NotificationList = () => {
  const token = localStorage.getItem("logged_in_user_token");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [data, setData] = useState([]);
  const [modal, setModal] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalNotifications, setTotalNotifications] = useState(0);
  const [category, setCategory] = useState("general");
  const navigate = useNavigate();
  const toast = useToast();

  const fetchData = () => {
    NotificationService.getNotification(token, page, pageSize, category)
      .then((res) => {
        setData(res.data.data);
        setTotalPages(res.data.totalPages);
        setTotalNotifications(res.data.totalNotifications);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });
  };

  const isNotificationdelete = (isdelete: any) => {
    fetchData();
  };
  {
    /* General 
Uncategorised 
Automatic 
Assessment 
EHC 
Single session 
Subscription 
Renew subscription 
Special day offer
Campaign */
  }
  const categoryArray = [
    {
      value: "general",
      name: "General",
    },
    {
      value: "uncategorized",
      name: "Uncategorised",
    },
    {
      value: "automatic",
      name: "Automatic",
    },
    {
      value: "assessment",
      name: "Assessment",
    },
    {
      value: "ehc",
      name: "EHC",
    },
    {
      value: "single_session",
      name: "Single session",
    },
    {
      value: "subscription",
      name: "Subscription",
    },
    {
      value: "renew_subscription",
      name: "Renew Subscription",
    },
    {
      value: "special_day_offer",
      name: "Special day offer",
    },
    {
      value: "campaign",
      name: "Campaign",
    },
  ];
  useEffect(() => {
    fetchData();
  }, [page, category]);

  return (
    <div className="main-wrapper">
      <div className="page_title py-2">
        Notifications - App Notification {`(${category.toUpperCase()})`}
      </div>

      <div className="p-4">
        {" "}
        <div className="notification-header d-flex justify-content-between align-items-center">
          <button
            type="button"
            className="btn action-btn custom-btn notification-action-btn notification-btn"
            onClick={() => navigate("add")}
          >
            Create Notification
          </button>
        </div>
        <div className="main-section d-flex">
          <div className="vertical-buttons" style={{ marginRight: "2rem" }}>
            <div className="categories-title mb-3">Categories</div>
            {categoryArray.map((el) => (
              <div className="notification-header d-flex justify-content-between align-items-center">
                <button
                  type="button"
                  className="btn action-btn notification-action-btn notification-btn custom-btn"
                  onClick={() => {
                    setCategory(el.value);
                    setPage(1);
                  }}
                >
                  {el.name}
                </button>
              </div>
            ))}
          </div>

          <div className="table-container notification-table-container">
            {data.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th>Edit</th>
                    <th>Id</th>
                    <th>Name</th>
                    <th>Title</th>
                    <th>Body</th>
                    <th>Path</th>
                    <th>Image</th>
                    <th>CreatedAt</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((el: any) => (
                    <SingleRowList
                      key={el._id}
                      id={el._id}
                      props={el}
                      func={isNotificationdelete}
                    />
                  ))}
                </tbody>
              </table>
            ) : (
              <h1 className="no-data">No Data Found</h1>
            )}
          </div>
        </div>
        <div className="row m-0 pagination pt-5">
          <div className="col-sm-6 p-lg-0">
            <p>
              Showing {(page - 1) * pageSize + 1} to{" "}
              {page * pageSize > totalNotifications
                ? totalNotifications
                : page * pageSize}{" "}
              of {totalNotifications} entries
            </p>
          </div>
          <div className="col-sm-6 p-lg-0 text-right">
            <div className="btn-group" role="group">
              <button
                type="button"
                className={
                  page === 1
                    ? "btn action-btn disabledButton "
                    : "btn action-btn"
                }
                onClick={() => setPage(page - 1)}
                disabled={page === 1 ? true : false}
              >
                {"<< Previous"}
              </button>
              <button type="button" className="btn action-btn selected">
                {page}
              </button>
              <button
                type="button"
                className={
                  page === totalPages || totalPages === 0
                    ? "btn action-btn disabledButton "
                    : "btn action-btn"
                }
                onClick={() => setPage(page + 1)}
                disabled={
                  page === totalPages || totalPages === 0 ? true : false
                }
              >
                {"Next >>"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
